import md5 from 'md5';
import { Tracker, TrackerConfig } from './Tracker.js';


export const createTracker = function (config) {
  const tracker = new Tracker(...config);
  if (process.env.SERVER) {
    tracker.params = {
      buyer_server: true
    };
  } else {
    let did = localStorage.getItem('sls_did');
    if (!did) {
      did = md5(`${navigator.userAgent}${+new Date()}${Math.random() * 999999999}`);
      localStorage.setItem('sls_did', did)
    }
    tracker.params = {
      buyer_client: true,
      location: window.location.href,
      did,
      agent: navigator.userAgent,
    };
  }
  return tracker;
};

/**
 * 基础日志上报
 * @param {*} data
 */
export const pushLog = (data = {}, mandatory = false) => {
  if (process.env.NODE_ENV === 'production' || mandatory) {
    const tracker = createTracker(TrackerConfig);
    tracker.push('timeStamp', +new Date())
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const i in data) {
      tracker.push(i, data[i]);
    }
    tracker.logger();
  } else {
    const tracker = createTracker(TrackerConfig);
    tracker.push('timeStamp', +new Date())
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const i in data) {
      tracker.push(i, data[i]);
    }
    tracker.logger();
  }
};
